import { render, staticRenderFns } from "./AllocationTracker.vue?vue&type=template&id=5b30cfc9&scoped=true"
import script from "./AllocationTracker.vue?vue&type=script&lang=js"
export * from "./AllocationTracker.vue?vue&type=script&lang=js"
import style0 from "./AllocationTracker.vue?vue&type=style&index=0&id=5b30cfc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b30cfc9",
  null
  
)

export default component.exports